import { useSearchParams } from "react-router-dom";
import { NativeSelect } from "@altimateai/lego";
import { SEARCH_PARAMS, SubscriptionType } from "@/pages/subscriptions/constants";

const TYPE_OPTIONS = [
  { label: "All Types", value: "all" },
  { label: "Report", value: SubscriptionType.REPORT },
  { label: "Alert", value: SubscriptionType.ALERT },
];

export const SubscriptionTypeFilter = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const subscriptionTypeFilter = searchParams.get(SEARCH_PARAMS.RULE_TYPE) || "all";

  const handleValueChange = (value: string) => {
    setSearchParams(
      prev => {
        if (value === "all") {
          prev.delete(SEARCH_PARAMS.RULE_TYPE);
        } else {
          prev.set(SEARCH_PARAMS.RULE_TYPE, value);
        }
        prev.delete("page");
        return prev;
      },
      { replace: true }
    );
  };

  return (
    <NativeSelect
      options={TYPE_OPTIONS}
      value={subscriptionTypeFilter}
      onChange={handleValueChange}
      className="al-w-[200px]"
      size="sm"
      variant="outline"
    />
  );
};
